/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var _ = require('underscore');
var moment = require('moment');
var cleanUpResponse = require('common/util/cleanUpResponse');

module.exports = function() {
  var defer = $.Deferred();

  $.soap({
    body: {
      GetEventsByOwner: {
        $xmlns: 'http://dobs.pa.gov/co/event/bpm/1.0'
      }
    },
    blueprintArrays: ['GetEventsByOwnerResponse.CO_Event'],
    blueprint: {
      events: [
        '$..CO_Event',
        {
          id: '$..ID',
          title: '$..Title',
          startDateTime: '$..StartDateTime',
          endDateTime: '$..EndDateTime',
          presenters: '$..Presenters',
          createdDate: '$..CreatedDate'
        }
      ]
    }
  })
    .done(function(response) {
      cleanUpResponse(response);

      _.each(response.events, function(event) {
        event.title = event.title || '--';
        event.startDateTime = moment(event.startDateTime, moment.ISO_8601);
        event.endDateTime = moment(event.endDateTime, moment.ISO_8601);
        event.presenters = event.presenters || '--';
        event.createdDate = moment(event.createdDate, moment.ISO_8601);
      });
      defer.resolve(response.events);
    })
    .fail(function(err) {
      defer.reject(err);
    });

  return defer.promise();
};
